import { Sizes } from "src/@types/sizes";

export const AVATAR_SIZE_VARIANTS = {
  [Sizes.XS]: "w-10.5 aspect-square",
  [Sizes.S]: "w-15  aspect-square",
  [Sizes.M]: "w-20.5 aspect-square",
  [Sizes.XXL]: "",
};
